import { render, staticRenderFns } from "./GridPortfolio.vue?vue&type=template&id=f4015cb0"
import script from "./GridPortfolio.vue?vue&type=script&lang=js"
export * from "./GridPortfolio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f4015cb0')) {
      api.createRecord('f4015cb0', component.options)
    } else {
      api.reload('f4015cb0', component.options)
    }
    module.hot.accept("./GridPortfolio.vue?vue&type=template&id=f4015cb0", function () {
      api.rerender('f4015cb0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/register/GridPortfolio.vue"
export default component.exports